export const Header = () => {
  return (
    <header>
      <a href="/">
        <img
          style={{
            // height: "50px",
            display: "block",
            margin: "10px",
          }}
          src="/Permobil_logo.svg"
          alt="Permobil"
        ></img>
      </a>
    </header>
  );
};
